import SmoothScroll from '@app/global/smoothScroll';
import { format as formatDate } from 'date-fns';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en';
import frLocale from 'date-fns/locale/fr';
var dateLocales = {
    de: deLocale,
    en: enLocale,
    fr: frLocale
};
export default {
    /**
     * Returns the source for an Image object
     *
     * @param image Image object
     * @param size Resize and cropping parameters (eg. "1200x800_crop", defaults to original size)
     * @param name Name of the file (overrides the original filename)
     */
    image: function (image, size, name) {
        if (size === void 0) { size = '0x0_ratio'; }
        if (name === void 0) { name = null; }
        if (!image) {
            return '';
        }
        if (image.extension.toLowerCase() === 'svg') {
            return "/media/".concat(image.hashId);
        }
        return "/img/".concat(image.hashId, "/").concat(size, "/").concat(name || image.localized.name, ".").concat(image.extension);
    },
    /**
     * Finds objects with a certain tag value
     *
     * @param items Array of taggable objects to search trough
     * @param tagValue The tag value to find
     */
    tagged: function (items, tagValue) {
        return items.filter(function (item) {
            // @ts-ignore
            return item.tags.find(function (tag) { return tag.value == tagValue; }) || false;
        });
    },
    /**
     * Finds the first object with a certain tag value
     *
     * @param items Array of taggable objects to search trough
     * @param tagValue The tag value to find
     */
    taggedFirst: function (items, tagValue) {
        return this.tagged(items, tagValue)[0] || null;
    },
    /**
     * Returns a localized string for a given translation key
     *
     * @param key Translation key
     */
    trans: function (key) {
        var parts = key.split('.');
        var current = window.TRANSLATIONS;
        var translation = null;
        if (typeof current[key] !== 'undefined') {
            return current[key];
        }
        for (var index in parts) {
            var partKey = parts[index];
            if (typeof current[partKey] !== 'undefined') {
                current = current[partKey];
                translation = current;
            }
        }
        if (typeof translation === 'string') {
            return translation;
        }
        else {
            return key;
        }
    },
    /**
     * Strips all HTML tags from a string
     *
     * @param string String of HTML content
     */
    stripTags: function (string) {
        var html = string;
        var div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    },
    /**
     * Scrolls smoothly to a given element
     *
     * @param target Element to scroll to
     * @param duration Duration of animation
     */
    scrollTo: function (target, duration) {
        if (duration === void 0) { duration = 300; }
        SmoothScroll(target, duration);
    },
    /**
     * Returns the currently set locale
     */
    locale: function () {
        return document.documentElement.getAttribute('lang');
    },
    /**
     * Emits a modal open event to the Vue root component
     *
     * @param caller Vue root element to notify
     * @param component Modal component
     */
    modal: function (caller, component) {
        caller.$emit('modal-open', component);
    },
    /**
     * Local storage helper functions
     */
    storage: {
        set: function (key, value) {
            try {
                localStorage.setItem('NITROUS_' + key, JSON.stringify(value));
            }
            catch (ex) {
                console.log('Could not write to locale storage', {
                    // @ts-ignore
                    message: ex.message
                });
            }
        },
        get: function (key) {
            var value = localStorage.getItem('NITROUS_' + key) || null;
            return value ? JSON.parse(value) : null;
        },
        remove: function (key) {
            localStorage.removeItem('NITROUS_' + key);
        }
    },
    /**
     * Local storage helper functions
     */
    session: {
        set: function (key, value) {
            try {
                sessionStorage.setItem('NITROUS_' + key, JSON.stringify(value));
            }
            catch (ex) {
                console.log('Could not write to locale storage', {
                    // @ts-ignore
                    message: ex.message
                });
            }
        },
        get: function (key) {
            var value = sessionStorage.getItem('NITROUS_' + key) || null;
            return value ? JSON.parse(value) : null;
        },
        remove: function (key) {
            sessionStorage.removeItem('NITROUS_' + key);
        }
    },
    /**
     * Returns a formatted and localized date string
     *
     * @param date Date string to format
     * @param format Format tokens
     */
    localizedDate: function (date, format) {
        if (format === void 0) { format = 'Do MMMM YYYY'; }
        return formatDate(date, format, {
            locale: dateLocales[this.locale() || 'de']
        });
    },
    /**
     * Returns a formatted and localized datetime string
     *
     * @param datetime Datetime string to format
     * @param format Format tokens
     */
    localizedDateTime: function (datetime, format) {
        if (format === void 0) { format = 'Do MMMM YYYY, HH:mm'; }
        return formatDate(datetime, format, {
            locale: dateLocales[this.locale() || 'de']
        });
    },
    debounceStack: [],
    debounce: function (delay, key) {
        var _this = this;
        if (key === void 0) { key = 'global'; }
        // @ts-ignore
        return new Promise(function (resolve) {
            clearTimeout(_this.debounceStack[key]);
            _this.debounceStack[key] = setTimeout(resolve, delay);
        });
    },
    isExternalLink: function (url) {
        var domain = window.location.protocol + "//" + window.location.hostname;
        if (url.indexOf("/media/") !== -1) {
            // Media download link
            return true;
        }
        else if (url.indexOf(domain) !== -1) {
            // Internal absolute
            return false;
        }
        else if (url.indexOf("http") === -1) {
            // Internal relative
            return false;
        }
        else {
            // External
            return true;
        }
    }
};
